// @flow
import Enum from '@rover/shared/js/types/Enum';
import { Font, FontSize, FontWeight, Color } from '@rover/kibble/styles';

export default class CalloutBadgeStyle extends Enum<{
  'background-color': Color,
  height: number,
  'border-radius': string,
  'border-width': string,
  'border-style': string,
  'border-color': Color | string,
  color: Color,
  'font-size': FontSize,
  'font-weight': FontWeight,
  'line-height': string,
  padding: string,
}> {
  static DEFAULT = new CalloutBadgeStyle({
    'background-color': Color.ORANGE_BASE,
    height: 20,
    'border-radius': '10px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.NEUTRAL_100,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.BOLDEST,
    'line-height': '1.6',
    padding: '0 6px',
  });

  static NEW = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_BASE,
    height: 20,
    'border-radius': '2px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.YELLOW_28,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.NORMAL,
    'line-height': '1.6',
    padding: '0 6px',
  });

  static HIGHEST_EARNERS = new CalloutBadgeStyle({
    'background-color': Color.ORANGE_BASE,
    height: 20,
    'border-radius': '10px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.NEUTRAL_100,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.NORMAL,
    'line-height': '1.6',
    padding: '0 6px',
  });

  static AWAY = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_96,
    height: 20,
    'border-radius': '4px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.ORANGE_40,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.BOLDEST,
    'line-height': '1.6',
    padding: '0 6px',
  });

  static HIGHLIGHTED_FEATURE = new CalloutBadgeStyle({
    'background-color': Color.NEUTRAL_100,
    height: 24,
    'border-radius': '4px',
    'border-color': Color.BLUE_28,
    'border-width': '1px',
    'border-style': 'solid',
    color: Color.BLUE_28,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.NORMAL,
    'line-height': '1.6',
    padding: '2px 4px',
  });

  static REPEAT_CLIENTS = new CalloutBadgeStyle({
    'background-color': Color.NEUTRAL_92,
    height: 24,
    'border-radius': '4px',
    'border-color': Color.BLUE_28,
    'border-width': '0px',
    'border-style': 'solid',
    color: Color.NEUTRAL_44,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.NORMAL,
    'line-height': '1.6',
    padding: '4px 12px',
  });

  static isLocked = true;

  toString() {
    return `
      background-color: ${this.value['background-color'].toString()};
      height:${this.value.height.toString()}px;
      border-radius: ${this.value['border-radius'].toString()};
      border-color: ${this.value['border-color'].toString()};
      border-width: ${this.value['border-width'].toString()};
      border-style: ${this.value['border-style'].toString()};
      color: ${this.value.color.toString()};
      font-size: ${this.value['font-size'].toString()};
      font-weight: ${this.value['font-weight'].toString()};
      line-height: ${this.value['line-height'].toString()};
      padding: ${this.value.padding.toString()};
    `;
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/components/callouts/CalloutBadge/CalloutBadge.constants.js